"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeliveryNoteOcrData = exports.isPurchaseOrderOcrData = exports.isInvoiceOcrData = void 0;
const models_1 = require("../models");
const isInvoiceOcrData = (ocrData) => {
    return ocrData._discriminator === models_1.DocumentTypeEnum.INVOICE;
};
exports.isInvoiceOcrData = isInvoiceOcrData;
const isPurchaseOrderOcrData = (ocrData) => {
    return ocrData._discriminator === models_1.DocumentTypeEnum.PURCHASE_ORDER;
};
exports.isPurchaseOrderOcrData = isPurchaseOrderOcrData;
const isDeliveryNoteOcrData = (ocrData) => {
    return ocrData._discriminator === models_1.DocumentTypeEnum.DELIVERY_NOTE;
};
exports.isDeliveryNoteOcrData = isDeliveryNoteOcrData;
